import { Link } from '@remix-run/react'
import { cn } from '~/utils/misc.tsx'

type Props = {
  variant: 'desktop' | 'mobile'
}
export default function Footer({ variant }: Props) {
  return (
    <div
      className={cn(
        `w-full items-center justify-center py-2 text-lg `,
        variant === 'desktop'
          ? 'hidden bg-gradient-to-r from-transparent via-gray-100 to-transparent bg-[length:100%_100%] sm:flex'
          : 'mt-10 flex bg-gray-100 sm:hidden',
      )}
    >
      <Link
        to={'/confidentiality'}
        className="text-center text-foreground hover:text-foreground-muted"
      >
        Confidencialidad
      </Link>
    </div>
  )
}
